import { useEffect, useState, useCallback } from "react";
import * as UserAPI from "../../../../src/service/userApi";
import { HashLoader } from "react-spinners";

const ROLE_LABEL = {
  PATIENT: "ประชาชนทั่วไป",
  MEDICAL_PERSONNEL: "แพทย์/เภสัช",
  LABORATORY_ADMIN: "ผู้ดูแลห้องปฏิบัติการ",
  LABORATORY_PERSONNEL: "ผู้ปฏิบัติการในห้องปฏิบัติการ",
  HOSPITAL_PERSONNEL: "เจ้าหน้าที่โรงพยาบาล",
  EXECUTIVE: "ผู้บริหาร",
  HOSPITAL: "โรงพยาบาล",
  ADMIN: "ผู้ดูแลระบบ/แอดมิน",
};

export default function ModalSwitchRole({ onClose }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const currentRole = user?.auth?.role?.[0];

  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(currentRole);
  const [loading, setLoading] = useState(false);

  const fetchRoles = useCallback(async () => {
    try {
      const res = await UserAPI.checkRole();
      if (res?.data?.code === 200) {
        setRoles(res.data.roles);
      }
    } catch (err) {
      console.error("Error fetching roles:", err);
    }
  }, []);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  const handleConfirm = async () => {
    if (selectedRole === currentRole) return;

    try {
      setLoading(true);
      const res = await UserAPI.switchRole(selectedRole);

      if (res?.data?.code === 200) {
        const auth = res.data.user_data.auth;
        localStorage.setItem("pg_access_token", auth.access_token);
        localStorage.setItem("expire_login_user", auth.access_token_expire);
        localStorage.setItem("user", JSON.stringify(res.data.user_data));
        window.location.replace("/");
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <img
          onClick={onClose}
          src={require("../../../asset/icon/close-icon.svg").default}
          alt="close"
          style={styles.close}
        />

        <div style={styles.title}>เปลี่ยนสิทธิ์การใช้งาน</div>
        <div style={styles.subtitle}>เลือกสิทธิ์ใช้งานของท่าน</div>

        {loading ? (
          <div className="flex flex-col justify-center items-center h-40 w-full">
            <HashLoader color="#FF9768" size={70} />
            <div
              style={{
                marginTop: "20px",
                color: "#FF9768",
                fontWeight: "600",
                fontSize: "18px",
              }}
            >
              loading...
            </div>
          </div>
        ) : (
          <div style={styles.roleList}>
            {roles.map((role) => (
              <button
                key={role}
                onClick={() => setSelectedRole(role)}
                style={{
                  ...styles.roleItem,
                  ...(selectedRole === role ? styles.roleActive : {}),
                }}
              >
                {ROLE_LABEL[role]}
              </button>
            ))}
          </div>
        )}

        <div style={styles.footer}>
          <button style={styles.cancelBtn} onClick={onClose}>
            ยกเลิก
          </button>

          <button
            style={styles.confirmBtn}
            loading={loading}
            onClick={handleConfirm}
          >
            ยืนยัน
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#fff",
    width: "100%",
    maxWidth: "420px",
    borderRadius: 10,
    padding: 24,
    position: "relative",
  },
  close: {
    position: "absolute",
    top: 16,
    right: 16,
    cursor: "pointer",
    width: 20,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    textAlign: "center",
    marginBottom: 8,
  },
  subtitle: {
    textAlign: "center",
    color: "#6b7280",
    fontSize: 20,
    marginBottom: 20,
  },
  roleList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  roleItem: {
    padding: "12px 10px",
    borderRadius: 6,
    border: "1px solid #d1fae5",
    background: "#ecfdf5",
    color: "#047857",
    cursor: "pointer",
    fontSize: 15,
  },
  roleActive: {
    border: "2px solid #3b82f6",
    background: "#eff6ff",
    color: "#1d4ed8",
    fontWeight: 600,
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 24,
    gap: "10px",
  },
  cancelBtn: {
    flex: 1,
    height: 44,
    borderRadius: 8,
    border: "1px solid #d1d5db",
    backgroundColor: "#f3f4f6",
    color: "#6b7280",
    fontSize: 16,
    fontWeight: 500,
    cursor: "pointer",
  },
  confirmBtn: {
    flex: 1,
    height: 44,
    borderRadius: 8,
    border: "none",
    backgroundColor: "#3b82f6",
    color: "#ffffff",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
  },
};
